import * as tslib_1 from "tslib";
import { OnInit, ErrorHandler } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../user/user.service';
import { State } from '../state-view/state.model';
import { ActionIconComponent } from '../action-icon/action-icon.component';
var AirportFavoriteIconComponent = /** @class */ (function () {
    function AirportFavoriteIconComponent(_auth, _userService, _errorHandler, _snackBar) {
        this._auth = _auth;
        this._userService = _userService;
        this._errorHandler = _errorHandler;
        this._snackBar = _snackBar;
        this.authenticated = false;
        this.state = State.Empty;
    }
    AirportFavoriteIconComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Update state based on latest event in authStream, and subscribe to any future
        // changes in authentication state.
        this._onAuthEvent(this._auth.authStream.getValue());
        this._auth.authStream.subscribe(function (e) { return _this._onAuthEvent(e); });
        // Update state based on latest available userInfo, and subscribe to any future
        // changes to userInfo.
        this._userInfo = this._userService.userInfo.getValue();
        this._userService.userInfo.subscribe(function (u) {
            // Update userInfo
            _this._userInfo = u;
            // Set state to loaded
            _this.state = State.Content;
        });
    };
    Object.defineProperty(AirportFavoriteIconComponent.prototype, "isFavorite", {
        get: function () {
            var _this = this;
            return this._userInfo && this._userInfo.favoriteAirports.some(function (f) { return f.identifier === _this.identifier; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFavoriteIconComponent.prototype, "tooltip", {
        get: function () {
            return this.isFavorite
                ? 'This airport is in your favorites (click to remove)'
                : 'Add to favorites';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFavoriteIconComponent.prototype, "icon", {
        get: function () {
            return this.isFavorite ? 'favorite' : 'favorite_border';
        },
        enumerable: true,
        configurable: true
    });
    AirportFavoriteIconComponent.prototype._onAuthEvent = function (e) {
        this.authenticated = this._auth.authenticated;
        if (this.authenticated && !this._auth.endUser) {
            // userInfo is not available when not authenticated as an end user, so set favorite state to loaded now.
            this.state = State.Content;
        }
    };
    AirportFavoriteIconComponent.prototype.toggleFavorite = function (v) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var snackBarOpts, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        this.state = State.Loading;
                        snackBarOpts = { duration: 2000 };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!v) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._userService.removeFavoriteAirport(this.identifier)];
                    case 2:
                        _a.sent();
                        this._snackBar.open(this.identifier + " was removed from your favorites.", 'Dismiss', snackBarOpts);
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._userService.addFavoriteAirport(this.identifier)];
                    case 4:
                        _a.sent();
                        this._snackBar.open(this.identifier + " was added to your favorites.", 'Dismiss', snackBarOpts);
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        this._snackBar.open('An error occurred updating your airport favorites. Please try again later.', 'Dismiss', snackBarOpts);
                        this._errorHandler.handleError(e_1);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.state = State.Error;
                        setTimeout(function () {
                            _this.state = State.Content;
                        }, 2000);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return AirportFavoriteIconComponent;
}());
export { AirportFavoriteIconComponent };
